import {
  getRegisterSMSVerifyCode,
  bindMobilephone,
  registerAndLoginByWechat,
} from '@/api/accountexserv'

export default {
  state: {
    state_AccountEx_GetRegisterSMSVerifyCodeResult: null,
    state_AccountEx_BindMobilephoneResult: null,
    state_AccountEx_RegisterAndLoginByWechatResult: null,
  },
  mutations: {
    SET_ACCOUNTEX_GETREGISTERSMSVERIFYCODE_RESULT: (state, rst) => {
      state.state_AccountEx_GetRegisterSMSVerifyCodeResult = rst;
    },
    SET_ACCOUNTEX_BINDMOBILEPHONE_RESULT: (state, rst) => {
      state.state_AccountEx_BindMobilephoneResult = rst;
    },
    SET_ACCOUNTEX_REGISTERANDLOGINBYWECHAT_RESULT: (state, rst) => {
      state.state_AccountEx_RegisterAndLoginByWechatResult = rst;
    },
  },
  actions: {
    AccountExServ_GetRegisterSMSVerifyCode({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getRegisterSMSVerifyCode(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOUNTEX_GETREGISTERSMSVERIFYCODE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOUNTEX_GETREGISTERSMSVERIFYCODE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AccountExServ_BindMobilephone({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindMobilephone(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOUNTEX_BINDMOBILEPHONE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOUNTEX_BINDMOBILEPHONE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AccountExServ_RegisterAndLoginByWechat({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        registerAndLoginByWechat(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOUNTEX_REGISTERANDLOGINBYWECHAT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOUNTEX_REGISTERANDLOGINBYWECHAT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_AccountEx_GetRegisterSMSVerifyCodeResult: state => {
      return state.state_AccountEx_GetRegisterSMSVerifyCodeResult;
    },
    get_AccountEx_BindMobilephoneResult: state => {
      return state.state_AccountEx_BindMobilephoneResult;
    },
    get_AccountEx_RegisterAndLoginByWechatResult: state => {
      return state.state_AccountEx_RegisterAndLoginByWechatResult;
    },
  }
}